var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3C1.25 2.0335 2.0335 1.25 3 1.25H21C21.9665 1.25 22.75 2.0335 22.75 3V7.79545C22.75 8.20967 22.4142 8.54545 22 8.54545C21.5858 8.54545 21.25 8.20967 21.25 7.79545V3C21.25 2.86193 21.1381 2.75 21 2.75H14.75V21.25H16C16.4142 21.25 16.75 21.5858 16.75 22C16.75 22.4142 16.4142 22.75 16 22.75H8C7.58579 22.75 7.25 22.4142 7.25 22C7.25 21.5858 7.58579 21.25 8 21.25H9.25V2.75H3C2.86193 2.75 2.75 2.86193 2.75 3V7.79545C2.75 8.20967 2.41421 8.54545 2 8.54545C1.58579 8.54545 1.25 8.20967 1.25 7.79545V3ZM10.75 2.75V21.25H13.25V2.75H10.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextAlt);
export default __webpack_public_path__ + "static/media/text-alt.e5cb79f5fc4206c49f46856ea1d52c24.svg";
export { ForwardRef as ReactComponent };